module.exports = __webpack_public_path__ + "static/media/expandCircle.c83322cf.svg";